import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Checkbox,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import AuthenticationService from "../../authentication/AuthenticationService";
import loggerFactory from "globals/logger/logger-factory";
import { application } from "globals/endpoints";

const ITEMS_PER_PAGE = 20; 

const Contact = ({ searchText }) => {
  const [contactList, setContactList] = useState([]); 
  const [filteredContactList, setFilteredContactList] = useState([]); 
  const [visibleContacts, setVisibleContacts] = useState([]); 
  const [page, setPage] = useState(1); 
  const [loading, setLoading] = useState(true); 
  const [loadingMore, setLoadingMore] = useState(false); 

  const fetchContactList = async () => {
    setLoading(true);
    try {
      const response = await application.post(`uc/phoneBook/listAll`);
      const allContacts = response.data.data || [];
        const validContacts = allContacts.filter(
          (contact) => contact?.designation || contact?.name
        );

      setContactList(validContacts);
      setFilteredContactList(validContacts); 
      setVisibleContacts(validContacts.slice(0, ITEMS_PER_PAGE)); 
    } catch (error) {
      loggerFactory.debug("Unable to get Contact List", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactList();
  }, []);

  useEffect(() => {
    const filtered = searchText
      ? contactList.filter(
          (contact) =>
            contact.offEXtn &&
            contact.offEXtn.toLowerCase().includes(searchText.toLowerCase())
        )
      : contactList;

    setFilteredContactList(filtered); 
    setPage(1); 
    setVisibleContacts(filtered.slice(0, ITEMS_PER_PAGE)); 
  }, [searchText, contactList]);

  useEffect(() => {
    if (page > 1) {
      setLoadingMore(true);
      const startIndex = (page - 1) * ITEMS_PER_PAGE;
      const endIndex = page * ITEMS_PER_PAGE;

      setTimeout(() => {
        setVisibleContacts((prev) => [
          ...prev,
          ...filteredContactList.slice(startIndex, endIndex),
        ]);
        setLoadingMore(false);
      }, 500); 
    }
  }, [page, filteredContactList]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 10 && !loadingMore) {
      const hasMore = page * ITEMS_PER_PAGE < filteredContactList.length;
      if (hasMore) {
        setPage((prev) => prev + 1); 
      }
    }
  };
const handleCheckboxChange = async (contact) => {
  try {
    if (!contact.blf) {
      const body = {
        sourceExtension: AuthenticationService.getExtensionNumber(),
        destinationExtension: [contact.offEXtn],
      };
      await application.post(`blfExtension/create`, body);
    } else {
      await application.post(`blfExtension/delete/${contact.offEXtn}`);
    }

    setContactList((prev) =>
      prev.map((item) =>
        item.id === contact.id ? { ...item, blf: !contact.blf } : item
      )
    );

    setFilteredContactList((prev) =>
      prev.map((item) =>
        item.id === contact.id ? { ...item, blf: !contact.blf } : item
      )
    );

    setVisibleContacts((prev) =>
      prev.map((item) =>
        item.id === contact.id ? { ...item, blf: !contact.blf } : item
      )
    );
  } catch (error) {
    loggerFactory.debug("Unable to update BLF extension", error);
  }
};

  return (
    <div>
      <MDBox
        style={{
          position: "sticky",
          top: 60,
          zIndex: 1,
          paddingBottom: "10px",
        }}
      >
        <Card style={{ backgroundColor: "gray", padding: "10px" }}>
          <Grid container alignItems="center">
            <Grid item xs={2}>
              <MDTypography variant="h6">DSS</MDTypography>
            </Grid>
            <Grid item xs={4}>
              <MDTypography variant="h6">Contact Number</MDTypography>
            </Grid>
            <Grid item xs={6}>
              <MDTypography variant="h6">Contact Name</MDTypography>
            </Grid>
          </Grid>
        </Card>
      </MDBox>
      <MDBox
        style={{ height: "65vh", overflowY: "auto" }}
        onScroll={handleScroll}
      >
        {loading ? (
          <Card style={{ height: "100%" }}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircularProgress color="info" />
              &nbsp;&nbsp;
              <Typography variant="h6" color="text">
                Loading Contact List...
              </Typography>
            </Box>
          </Card>
        ) : visibleContacts.length === 0 ? (
          <Typography variant="h6" color="text" align="center">
            No Contacts Found
          </Typography>
        ) : (
          <Grid container spacing={2}>
            {visibleContacts.map((contact) => (
              <Grid item xs={12} key={contact.id}>
                <Card>
                  <Box p={1}>
                    <Grid container alignItems="center">
                      <Grid item xs={2}>
                        <Checkbox
                          checked={contact.blf}
                          onChange={() => handleCheckboxChange(contact)}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <MDTypography variant="caption text">
                          {contact?.offEXtn}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={6}>
                        <MDTypography variant="caption text">
                          {contact?.designation || contact?.name}
                        </MDTypography>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
        {loadingMore && (
          <Box display="flex" justifyContent="center" mt={2}>
            <CircularProgress color="info" />
          </Box>
        )}
      </MDBox>
    </div>
  );
};

export default Contact;
